<div class="adlg-hist-list">
  <div class="adlg-hist-item" *ngFor="let row of rows; trackBy: trackRow" [class.open]="openId === row.id">
    <div class="adlg-hist-row current" *ngIf="row.id === viewingId; else expandable" [attr.data-alert-id]="row.id">
      <ng-container *ngTemplateOutlet="histHead; context: { $implicit: row, viewing: true }"></ng-container>
      <span></span>
    </div>
    <ng-template #expandable>
      <button type="button" class="adlg-hist-row" [attr.data-alert-id]="row.id"
              [attr.aria-expanded]="openId === row.id" [attr.aria-controls]="'adlg-hist-' + row.id"
              (click)="toggle(row)">
        <ng-container *ngTemplateOutlet="histHead; context: { $implicit: row, viewing: false }"></ng-container>
        <mat-icon class="adlg-hist-go" aria-hidden="true">expand_more</mat-icon>
      </button>
      <div class="adlg-hist-panel" role="region" *ngIf="openId === row.id" [id]="'adlg-hist-' + row.id">
        <span class="adlg-hist-k">{{ '@triggeredFault' | translate }}</span>
        <div class="adlg-hist-v adlg-hist-faults" *ngIf="triggeredFaults[row.id] | async as faults; else histLoading">
          <ng-container *ngIf="faults !== 'error'; else histError">
            <div class="adlg-hist-fault" *ngFor="let fault of faults">
              <span class="adlg-fr-base">{{ fault.description || fault.faultCodeDisplay }}</span>
              <span class="adlg-fr-code">{{ codeLabel(fault) }}</span>
              <span class="adlg-fr-code" [matTooltip]="'@faultCount' | translate">× {{ fault.faultCount }}</span>
            </div>
            <span *ngIf="!faults.length">—</span>
          </ng-container>
        </div>
        <span class="adlg-hist-k">{{ '@warningLamps' | translate }}</span>
        <div class="adlg-hist-v adlg-hist-lamps">
          <span class="adlg-hist-lamp" *ngFor="let lamp of row.lamps" [class.on]="lamp.on" [attr.data-lamp]="lamp.key">
            <img class="adlg-lamp-mini" [class.on]="lamp.on" [src]="lampSrc(lamp)" [alt]="(lamp.on ? lamp.onKey : lamp.offKey) | translate">
            {{ lamp.labelKey | translate }}
          </span>
        </div>
        <span class="adlg-hist-k">{{ '@location' | translate }}</span>
        <div class="adlg-hist-v adlg-hist-where">{{ row.shopName ?? ('@otr' | translate) }}</div>
        <ng-container *ngIf="relations[row.id] as rel">
          <ng-container *ngIf="rel.kind !== 'none'">
            <span class="adlg-hist-k">{{ '@case' | translate }}</span>
            <div class="adlg-hist-v adlg-hist-case" [attr.data-case-relation]="rel.kind">
              <ng-container *ngTemplateOutlet="caseLabel; context: { $implicit: rel, full: true }"></ng-container>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-template>
  </div>
</div>

<ng-template #histHead let-row let-viewing="viewing">
  <span class="adlg-hist-when" [matTooltip]="row.firedAtUtc | date:'medium'">
    {{ row.firedAtUtc | timeAgo }}<span class="adlg-you" *ngIf="viewing">{{ '@viewing' | translate }}</span>
  </span>
  <span class="adlg-hist-sev"><span class="adlg-dot" [ngClass]="'sev-' + row.severity.toLowerCase()"></span>{{ row.severity }}</span>
  <span class="adlg-lamps-mini">
    <img class="adlg-lamp-mini" *ngFor="let lamp of row.lamps" [class.on]="lamp.on" alt=""
         [src]="lampSrc(lamp)" [matTooltip]="(lamp.on ? lamp.onKey : lamp.offKey) | translate">
  </span>
  <span><ng-container *ngIf="relations[row.id] as rel">
    <span class="adlg-case-chip" *ngIf="rel.kind !== 'none'" [ngClass]="rel.kind" [attr.data-case-relation]="rel.kind">
      <ng-container *ngTemplateOutlet="caseLabel; context: { $implicit: rel, full: false }"></ng-container>
    </span>
  </ng-container></span>
</ng-template>

<ng-template #caseLabel let-rel let-full="full">
  <ng-container *ngIf="rel.orderNumber">#{{ rel.orderNumber }} · </ng-container>
  <ng-container [ngSwitch]="rel.kind">
    <ng-container *ngSwitchCase="'same'">{{ (full ? '@sameCaseAsAlert' : '@sameCase') | translate }}</ng-container>
    <ng-container *ngSwitchCase="'other-open'">{{ rel.statusKey | translate }}</ng-container>
    <ng-container *ngSwitchCase="'other-closed'">{{ full && rel.closedUtc ? ('@closedOnDate' | translate: { date: rel.closedUtc | date:'mediumDate' }) : ('@closed' | translate) }}</ng-container>
  </ng-container>
</ng-template>

<ng-template #histLoading>
  <div class="adlg-hist-v"><mat-progress-spinner mode="indeterminate" diameter="16"></mat-progress-spinner></div>
</ng-template>

<ng-template #histError>
  <span class="adlg-error">{{ '@loadError' | translate }}</span>
</ng-template>
